// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".workers-detail-table .b-table th:last-child div{display:block;text-align:right}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
